module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/DZ-c9f476690010dd80bbc274e171ceb982.png";